module.exports = __webpack_public_path__ + "static/media/p3a2.f5beeb8d.wav";